import { uniqBy } from "es-toolkit/compat";

import type { GetParentContextById } from "../../state/index.ts";
import type { DesignerNode, GetManifestByTypeId, ValueDescriptor } from "../../types/index.ts";

interface CreateOptions {
  getManifest: GetManifestByTypeId;
  getParentContext: GetParentContextById;
}

export const getNodeValuesCreate = ({ getManifest, getParentContext }: CreateOptions) => {
  return (node: DesignerNode): ValueDescriptor[] => {
    const {
      designer: { getValues },
    } = getManifest(node.typeId);
    if (!getValues) return [];

    const parentContext = getParentContext(node.id);

    const values = getValues(node, { parentContext }).filter(
      (value): value is Exclude<typeof value, undefined | false> => !!value,
    );
    if (uniqBy(values, "name").length !== values.length) {
      throw new Error(`Value names not unique on 'getValues()' on Node Designer of type ${node.typeId}`);
    }
    return values;
  };
};

export type GetNodeValues = ReturnType<typeof getNodeValuesCreate>;
